import React from 'react';
import { MessageCircle, AlertCircle, Clock, Brain } from 'lucide-react';
export function PainSection() {
  const painPoints = [{
    icon: MessageCircle,
    text: 'Clients scattered across endless WhatsApp chats'
  }, {
    icon: AlertCircle,
    text: 'Missed follow-ups and lost context'
  }, {
    icon: Clock,
    text: 'Appointments tracked in your head or loose notes'
  }, {
    icon: Brain,
    text: 'Constant feeling of "did I forget something?"'
  }];
  return <section className="py-16 px-6 bg-[#A39B8B]/10 rounded-3xl mx-4 md:mx-auto max-w-4xl my-8" data-id="element-73">
      <div className="max-w-2xl mx-auto" data-id="element-74">
        <h2 className="text-2xl md:text-3xl font-bold text-[#2D2D2D] mb-8 text-center" data-id="element-75">
          Does your WhatsApp feel like a chaotic to-do list?
        </h2>

        <div className="grid gap-4 mb-10" data-id="element-76">
          {painPoints.map((point, index) => <div key={index} className="flex items-start p-4 bg-white/60 rounded-xl border border-white/50" data-id="element-77">
              <point.icon className="w-6 h-6 text-[#A39B8B] mr-4 flex-shrink-0 mt-0.5" data-id="element-78" />
              <span className="text-[#2D2D2D] font-medium" data-id="element-79">{point.text}</span>
            </div>)}
        </div>

        <p className="text-center text-lg font-medium text-[#7B9AAA]" data-id="element-80">
          Welma removes this mental load, quietly.
        </p>
      </div>
    </section>;
}